import * as React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { PermissionsEditor } from "./permissions-editor";
import { CUSTOMIZABLE_ROLES, ROLE_DISPLAY_NAMES } from "@/lib/permissions";
import type { Role } from "@/lib/permissions";

export function PermissionsSection() {
  const [selectedRole, setSelectedRole] = React.useState<Role>(
    CUSTOMIZABLE_ROLES[0]!
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Role Permissions</CardTitle>
        <CardDescription>
          Customize what each role can do in your pharmacy. Overrides apply to
          all users with the selected role.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center gap-3">
          <label
            htmlFor="role-selector"
            className="text-sm font-medium whitespace-nowrap"
          >
            Select role
          </label>
          <Select
            value={selectedRole}
            onValueChange={(val) => setSelectedRole(val as Role)}
          >
            <SelectTrigger id="role-selector" className="w-[240px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {CUSTOMIZABLE_ROLES.map((role) => (
                <SelectItem key={role} value={role}>
                  {ROLE_DISPLAY_NAMES[role]}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <PermissionsEditor
          key={selectedRole}
          role={selectedRole}
          description={
            <>
              Changes apply to{" "}
              <strong>all {ROLE_DISPLAY_NAMES[selectedRole]}</strong> users in
              this pharmacy.
            </>
          }
        />
      </CardContent>
    </Card>
  );
}
